import { Outlet, Navigate } from 'react-router-dom';
import { isLoggedIn } from '../../services/auth';
import React, { useEffect, useState } from 'react';

const Callback = () => {
    const [loggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        const loggedIn = isLoggedIn();
        setLoggedIn(loggedIn);  
    }, []);
    
    return (
        loggedIn ? <Navigate to="/ava-admin/topics" /> : <Navigate to="/ava-admin/login" />
    )
};

export default Callback;